import { Arguments, Payment } from '@repo-level/core-front';

import { PAYMENTS_REDIRECT_ROUTES } from './constants';
import {
  sendDepositPaymentMethodsFailedLoading,
  sendDepositPaymentSubmitError,
} from 'modules/googleAnalytics';

export const fetchPaymentMethods = (
  currencyCode: string,
  paymentAction = Payment.Action.Deposit
) => {
  const isDeposit = paymentAction === Payment.Action.Deposit;

  if (!window.PaymentsAPI) {
    if (isDeposit) {
      sendDepositPaymentMethodsFailedLoading({ error: 'no_payments_lib' });
    }
    return Promise.resolve({ data: [] });
  }

  return (
    window.PaymentsAPI?.getMethods({
      currency: currencyCode,
      paymentAction,
    })
      .then((response) => {
        if (isDeposit && (!response || !response.length)) {
          sendDepositPaymentMethodsFailedLoading({
            error: `empty_value: ${response}; currency: ${currencyCode}`,
          });
        }
        return { data: response || [] };
      })
      .catch((error) => {
        console.error('Payment methods error', error);

        if (isDeposit) {
          sendDepositPaymentMethodsFailedLoading({ error });
        }
        return { data: [] };
      }) || Promise.resolve({ data: [] })
  );
};

export const getMethodFields = (
  args: Omit<Arguments.GetMethodFieldsArgs, 'paymentAction'>,
  paymentAction = Payment.Action.Deposit
) => {
  return (
    window.PaymentsAPI?.getMethodFields({
      paymentAction,
      ...args,
    })
      .then((res) => ({ data: res }))
      .catch((error) => {
        console.error('Get method fields error', error);
        return { data: error };
      }) || Promise.reject({ data: undefined })
  );
};

export const deleteSavedPaymentMethod = (
  args: Omit<Arguments.DeleteSavedProfileArgs, 'paymentAction'>
) => {
  return (
    window.PaymentsAPI?.deleteSavedProfile({
      ...args,
      paymentAction: Payment.Action.Deposit,
    })
      .then(() => ({ data: undefined }))
      .catch((error) => {
        return { data: error };
      }) || Promise.resolve({ data: undefined })
  );
};

export const submitFormPayment = (
  args: Omit<Arguments.SubmitArgs, 'paymentAction'>,
  paymentAction = Payment.Action.Deposit
) => {
  return (
    window.PaymentsAPI?.submit({
      ...args,
      paymentAction,
    })
      .then((res) => ({ data: res }))
      .catch((error) => {
        return { data: error };
      }) || Promise.reject({ data: undefined })
  );
};

export const resetCachePayments = () => {
  return (
    window.PaymentsAPI?.resetCache().catch(() => {
      console.error('Payments reset cache error');
    }) || Promise.reject()
  );
};

const buildStatusUrl = (eventId?: string) => (path?: string) =>
  `${window.location.origin}${path}${eventId ? `?event_id=${eventId}` : ''}`;

export const configPayments = (language: string, eventId?: string) => {
  const statusUrl = buildStatusUrl(eventId);

  const successUrl = statusUrl(PAYMENTS_REDIRECT_ROUTES.SUCCESS);
  const failureUrl = statusUrl(PAYMENTS_REDIRECT_ROUTES.FAILURE);
  const pendingUrl = statusUrl(PAYMENTS_REDIRECT_ROUTES.PENDING);
  const supportUrl = statusUrl(PAYMENTS_REDIRECT_ROUTES.SUPPORT);

  return (
    window.PaymentsAPI?.config({
      language,
      redirectRoutes: {
        successUrl,
        failureUrl,
        pendingUrl,
        supportUrl,
      },
    }) || Promise.reject
  );
};
